import { useJurisdiction } from "@/hooks/useJurisdiction";
import { getDisclaimerPack } from "@/lib/jurisdiction";
import { useLocale } from "@/i18n/locale-context";
import { CountrySelector } from "./CountrySelector";
import { Link } from "@tanstack/react-router";

export function Footer() {
  const { locale } = useLocale();
  const { jurisdiction } = useJurisdiction();
  const pack = getDisclaimerPack(jurisdiction, locale);
  return (
    <footer className="border-t border-foreground/5 mt-16 py-6 bg-background/60">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
        <p className="text-xs text-muted-foreground max-w-3xl">
          {pack.footer} <span className="text-muted-foreground/70">· {pack.emergency}</span>
        </p>
        <div className="flex items-center gap-4">
          <Link to="/faq" className="text-xs text-muted-foreground hover:text-foreground">
            FAQ & {locale === "fr" ? "Suggestions" : locale === "nl" ? "Suggesties" : "Suggestions"}
          </Link>
          <CountrySelector />
        </div>
      </div>
    </footer>
  );
}
